module.exports = {
  key: "authentication",

  authentication: {
    layout: {
      auth_layout: {
        title: "البرز",
      },
    },
    components: {
      auth: {
        title: "ورود کاربران",
        buttons: {
          submit_text: "ورود",
          forgotten_password: "فراموشی رمز عبور",
        },
      },
      register: {
        title: "ثبت نام",
        buttons: {
          submit_text: "ثبت نام",
        },
      },
      forget_password: {
        reset_password: "Reset Password",
        info: "If you have forgotten your password, you can reset it here",
        reset: "Send Link",
        success: "Reset link sent to your email.",
        toLogin: "Back to login",
        reset_success: "Your password successfully changed",
        change_password: "Change your password",
        change_password_btn: "Change Password",
      },
      login_footer: {
        copy_right: "Copyright &copy; 2021",
        company_name: "APP MAKER",
        developed_by: "Developed by Sepantech AB",
      },
    },

  },
  attribute: {
    mobile_number: "شماره موبایل",
    password: "کلمه ی عبور",
    confirm_password: "تکرار کلمه عبور",
    code: "کد",
    resend_code: "ارسال مجدد کد",
    null: "",
  },
  placeholder: {
    mobile_number: "09**",
    password: "کلمه ی عبور",
    confirm_password: "تکرار کلمه ی عبور",
    email: "email",
    null: "",
    code: "",
    default: "Type something...",
  },
};
